import React, { useEffect, useState, useRef } from 'react';
import App from "../../App";
import { AiOutlineArrowLeft, FaPrint, FiEye } from "react-icons/all";
import { Link, withRouter, useParams, useHistory } from "react-router-dom";
import Loader from 'react-loader';
import { getData, deleteData, putData } from '../../services/baseServices'
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import ReactToPrint from "react-to-print";
import ChallanCopy from './ChallanCopy';
import { humanize, getFormattedDate } from '../../helper/utils';
import ConfirmationModal from "../common/Modal";
import _ from 'lodash'
import { toast } from 'react-toastify';
import { DEBOUNCE_TIME } from "../../helper/env"

const BackwardChallanDetails = () => {
    const [challanDetails, setChallanDetails] = useState({})
    const [loading, setLoading] = useState(false)
    const componentRef = useRef();
    const {id} = useParams();
    const history = useHistory()

    const getChallan = () => {
      getData(`return_challans/${id}`)
      .then(res => {
        setChallanDetails(res?.data)
        setLoading(false)
      })
      .catch(errMsg => {
        console.log('Error Message: ', errMsg)
        history.push('/return-challan/list')
        setLoading(false)
      });
    }
  
    useEffect (() =>{
        setLoading(true)
        getChallan()
    }, [])

    const handleRemoveOrder = (orderId, order_type) => {
      deleteData(`return_challans/${challanDetails?.id}/remove_order`, {orderable_id: orderId, orderable_type: order_type})
        .then(res => {
            if(res.success){
              toast.success(res?.message);
              // history.push(`/return-challan/list`);
              history.go(0)
            } else {
                toast.error(res?.message)
            }
        })
        .catch(errMsg => {
            toast.error(errMsg)
        })
    }

    const dispatchChallan = (challanId)=>{
      putData(`return_challans/${challanId}/dispatch`)
        .then(res => {
          if(res.success) {
            toast.success(res.message);
            // history.push(`/return-challan/details/${challanId}`);
            history.go(0)
          }
          else {
            toast.error(res.message);
          }
        })
        .catch(errMsg => {
          toast.error(errMsg);
        }); 
    }

    const debouncedOnDispatch = _.debounce((challanId)=>{
      dispatchChallan(challanId)
    }, DEBOUNCE_TIME);
  
    const debouncedOnDispatchChallan = (challanId) => {
      debouncedOnDispatch(challanId);
    }

      return (
        <App layout="">
          <div className="page-header">
            <h2 className="page-title">Return Challan Details</h2>
            <div className="ml-auto">
              <Link to="/return-challan/list"
                    className="btn btn-sm btn-link mr-2"><AiOutlineArrowLeft/> Back to List</Link>
            </div>
          </div>
          <div className="d-flex justify-content-end mb-2 mr-2">
          {
                challanDetails.status === 'initiated'
                ?
                <OverlayTrigger
                key="view"
                placement="top"
                overlay={
                <Tooltip id={`tooltip-view`}>Send to FC</Tooltip>
                }
            >
                <ConfirmationModal 
                    customBtn = {true}
                    btnText = "Send to FC"
                    variant = "primary"
                    title="Send to DH" 
                    body="Are you sure to dispatch the challan?" 
                    handleAction={() =>debouncedOnDispatchChallan(challanDetails.id)}/>
              </OverlayTrigger>
              :
              <button className='btn btn-sm btn-primary' disabled>
                Send to FC
              </button>
            }
            <ReactToPrint
              trigger={() => {
                return (<a href="#">
                  <Button className='ml-2' variant={"default"}  size={"sm"}><FaPrint/> Print Challan
                  </Button>
                </a>)
              }}
              content={() => componentRef.current}
            />
          </div>
          
          <div ref={componentRef}>
            <ChallanCopy 
              orderItems={[]} 
              cancelledOrders={challanDetails?.customer_orders || []} 
              returnRequests = {challanDetails?.return_customer_orders || []}
              to={challanDetails?.fulfillment_center} 
              from={challanDetails?.distributor}/>
          </div>
            
          <div className="main-content">
              <Loader loaded={!loading}>
                  <div className="card-block">
                      <div className="block-body">
                          <table className="info-table">
                              <tbody>
                                <tr>
                                    <td style={{width: '200px'}}>Challan No</td>
                                    <td style={{width: '20px', textAlign: 'center'}}>:</td>
                                    <td className={`text-bold`}>{challanDetails?.id}</td>
                                </tr>
                                <tr>
                                    <td style={{width: '200px'}}>Status</td>
                                    <td style={{width: '20px', textAlign: 'center'}}>:</td>
                                    <td>{humanize(challanDetails?.status)}</td>
                                </tr>
                                <tr>
                                        <td style={{width: '200px'}}>Created At</td>
                                        <td style={{width: '20px', textAlign: 'center'}}>:</td>
                                        <td>{getFormattedDate(challanDetails?.created_at, 'DD-MM-YYYY')}</td>
                                    </tr>
                                    <tr>
                                        <td style={{width: '200px'}}>Total Orders</td>
                                        <td style={{width: '20px', textAlign: 'center'}}>:</td>
                                        <td>{challanDetails?.customer_orders?.length}</td>
                                    </tr>
                                    <tr>
                                        <td style={{width: '200px'}}>Total Return Requests</td>
                                        <td style={{width: '20px', textAlign: 'center'}}>:</td>
                                        <td>{challanDetails?.return_customer_orders?.length}</td>
                                    </tr>
                                    {
                                        challanDetails?.status !== 'initiated' &&
                                        <>
                                            <tr>
                                                <td style={{width: '200px'}}>Received Orders</td>
                                                <td style={{width: '20px', textAlign: 'center'}}>:</td>
                                                <td>{challanDetails?.customer_orders?.filter(i=>i.return_challan_line_item_status === 'received_by_fc')?.length}</td>
                                            </tr>
                                            <tr>
                                                <td style={{width: '200px'}}>Received Return Requests</td>
                                                <td style={{width: '20px', textAlign: 'center'}}>:</td>
                                                <td>{challanDetails?.return_customer_orders?.filter(i=>i.return_challan_line_item_status === 'received_by_fc')?.length}</td>
                                            </tr>
                                        </>
                                    }
                              </tbody>
                          </table>
                          {
                             challanDetails?.customer_orders?.length > 0 &&
                             <>
                              <h6 className='mt-3'>Order List</h6>
                          <table className="order-table table table-striped">
                            <thead>
                              <tr>
                                <th>Order Id</th>
                                <th>Amount</th>
                                <th>Status</th>
                                <th>Shipping Type</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {
                                challanDetails?.customer_orders?.map((lineItem, index)=>{
                                  return(
                                    <tr key={index}>
                                      <td>{lineItem?.id}</td>
                                      <td>{lineItem?.total_price}</td>
                                      <td>{humanize(lineItem?.return_challan_line_item_status)}</td>
                                      <td>{lineItem?.shipping_type}</td>
                                      <td>
                                        
                                        <div className="btn-group">
                                          <OverlayTrigger
                                            key="view"
                                            placement="top"
                                            overlay={
                                              <Tooltip id={`tooltip-view`}>View</Tooltip>
                                            }
                                          >
                                            <Link
                                              to={`/customerOrder/details/${lineItem?.id}`}
                                              className="btn btn-sm btn-default"
                                            >
                                              <FiEye />
                                            </Link>
                                          </OverlayTrigger>
                                            {
                                              challanDetails?.status === 'initiated' &&
                                                <OverlayTrigger
                                                key="view"
                                                placement="top"
                                                overlay={
                                                <Tooltip id={`tooltip-view`}>Remove</Tooltip>
                                                }
                                            >
                                                <ConfirmationModal title="Delete" body="Are you sure you want to remove?" handleAction={() => handleRemoveOrder(lineItem?.id, 'CustomerOrder')}/>
                                              </OverlayTrigger>
                                            }
                                        </div>
                                      </td>
                                    </tr>
                                  )
                                })
                              }
                            </tbody>
                          </table>
                             </>
                          }
                          
                          {
                            challanDetails?.return_customer_orders?.length > 0 &&
                            <>

                          <h6 className='mt-3'>Return Order List</h6>
                          <table className="order-table table table-striped">
                            <thead>
                              <tr>
                                <th>Return Id</th>
                                <th>Amount</th>
                                <th>Status</th>
                                <th>Return Type</th>
                                {challanDetails?.status === 'initiated' && <th>Action</th>}
                              </tr>
                            </thead>
                            <tbody>
                              {
                                challanDetails?.return_customer_orders?.map((lineItem, index)=>{
                                  return(
                                    <tr key={index}>
                                      <td>{lineItem?.id}</td>
                                      <td>{lineItem?.sub_total}</td>
                                      <td>{humanize(lineItem?.return_challan_line_item_status)}</td>
                                      <td>{lineItem?.return_type}</td>
                                      {
                                        challanDetails?.status === 'initiated' &&
                                        <td>
                                          <div className="btn-group">
                                              <OverlayTrigger
                                              key="view"
                                              placement="top"
                                              overlay={
                                              <Tooltip id={`tooltip-view`}>Remove from Challan</Tooltip>
                                              }
                                          >
                                              <ConfirmationModal title="Delete" body="Are you sure you want to remove?" handleAction={() => handleRemoveOrder(lineItem?.id, 'ReturnCustomerOrder')}/>
                                            </OverlayTrigger>
                                              
                                          </div>
                                        </td>
                                      }
                                    </tr>
                                  )
                                })
                              }
                            </tbody>
                          </table>
                            </>

                          }
                      </div>
                  </div>
              </Loader>
          </div>
        </App>
      );
    }
  
  export default withRouter(BackwardChallanDetails);
